/**
 * Price-chart canvas geometry (F12, plan §1.6 · §3.3).
 *
 * Fixed 900×300 viewBox: the chart is not responsive by design, so these are
 * layout facts rather than tuning knobs. They live here, not beside the React
 * component, because the path builder in `layout/chart-path.ts` is pure and
 * property-tested and must not reach into `apps/web` for its own dimensions.
 */

/** viewBox width. x = 0 is the first bar, x = width the last. */
export const CHART_WIDTH = 900;
/** viewBox height. SVG y grows DOWNWARD: a higher price is a SMALLER y. */
export const CHART_HEIGHT = 300;
/** Vertical inset of the plot area from the viewBox edge, top and bottom. */
export const CHART_PAD = 14;
/** Client-only decimation ceiling for long live windows (plan §6.5b / F12). */
export const CHART_MAX_POINTS = 400;
/** Horizontal grid lines drawn across the plot area. */
export const CHART_GRID_LINES = 5;
/** Decimal places in emitted coordinates — keeps the `d` attribute stable. */
export const CHART_PRECISION = 2;

/** Inset of a text label from the viewBox edge. */
export const CHART_LABEL_INSET_X = 6;
/** Baseline of the high-price label, measured from the top. */
export const CHART_LABEL_HIGH_Y = 26;
/** Distance of the low-price / bar-count label baseline from the bottom. */
export const CHART_LABEL_LOW_Y_OFFSET = 18;
/** First session-date x — clears the low-price money label (not `leftX`). */
export const CHART_FIRST_SESSION_X = 72;
/** Interior y-tick baseline offset below a grid line. */
export const CHART_INTERIOR_TICK_DY = 4;

/** RSI / MACD pane viewBox height. Pairs with `--study-pane-canvas-h`. */
export const OSCILLATOR_HEIGHT = 96;
/** Vertical inset of an oscillator plot, top and bottom. */
export const OSCILLATOR_PAD = 10;
